import TheEdit, { getServerSideProps as getServerProps } from './[page]'

export const getServerSideProps = getServerProps

export default TheEdit
